var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column gap-6"},[_c('basic-question',{attrs:{"kind":"radio","title":"Como está sua asma hoje?","questionData":{
      options: {
        'Muito ruim': 0,
        Ruim: 1,
        Bem: 2,
        'Muito bem': 3,
      },
    },"disabled":_vm.disabled},model:{value:(_vm.modelValue.overallSituation),callback:function ($$v) {_vm.$set(_vm.modelValue, "overallSituation", $$v)},expression:"modelValue.overallSituation"}}),_c('basic-question',{attrs:{"kind":"radio","title":"O quanto a sua asma atrapalha quando você corre, faz exercício físico ou pratica esportes?","questionData":{
      options: {
        'Atrapalha muito, eu não posso fazer o que eu quero': 0,
        'Atrapalha um pouco e eu não gosto disso': 1,
        'Atrapalha só um pouquinho, mas eu nem ligo': 2,
        'Não atrapalha nada': 3,
      },
    },"disabled":_vm.disabled},model:{value:(_vm.modelValue.blockedActivitiesRate),callback:function ($$v) {_vm.$set(_vm.modelValue, "blockedActivitiesRate", $$v)},expression:"modelValue.blockedActivitiesRate"}}),_c('basic-question',{attrs:{"kind":"radio","title":"Você tosse por causa de sua asma?","questionData":{
      options: {
        'Sim, o tempo todo': 0,
        'Sim, a maior parte do tempo': 1,
        'Sim, algumas vezes': 2,
        'Não, nunca': 3,
      },
    },"disabled":_vm.disabled},model:{value:(_vm.modelValue.coughingRate),callback:function ($$v) {_vm.$set(_vm.modelValue, "coughingRate", $$v)},expression:"modelValue.coughingRate"}}),_c('basic-question',{attrs:{"kind":"radio","title":"Você acorda durante a noite por causa de sua asma?","questionData":{
      options: {
        'Sim, o tempo todo': 0,
        'Sim, a maior parte do tempo': 1,
        'Sim, algumas vezes': 2,
        'Não, nunca': 3,
      },
    },"disabled":_vm.disabled},model:{value:(_vm.modelValue.nightAwakeningsRate),callback:function ($$v) {_vm.$set(_vm.modelValue, "nightAwakeningsRate", $$v)},expression:"modelValue.nightAwakeningsRate"}}),_c('basic-question',{attrs:{"kind":"radio","title":"Durante as últimas 4 semanas, quantos dias a criança teve algum sintoma da asma durante o dia?","questionData":{
      options: {
        Nenhum: 5,
        '1 a 3 dias': 4,
        '4 a 10 dias': 3,
        '11 a 18 dias': 2,
        '19 a 24 dias': 1,
        'Todos os dias': 0,
      },
    },"disabled":_vm.disabled},model:{value:(_vm.modelValue.parentSymptomsRate),callback:function ($$v) {_vm.$set(_vm.modelValue, "parentSymptomsRate", $$v)},expression:"modelValue.parentSymptomsRate"}}),_c('basic-question',{attrs:{"kind":"radio","title":"Durante as últimas 4 semanas, quantos dias a criança teve chiado no peito durante o dia por causa da asma?","questionData":{
      options: {
        Nenhum: 5,
        '1 a 3 dias': 4,
        '4 a 10 dias': 3,
        '11 a 18 dias': 2,
        '19 a 24 dias': 1,
        'Todos os dias': 0,
      },
    },"disabled":_vm.disabled},model:{value:(_vm.modelValue.parentWheezingRate),callback:function ($$v) {_vm.$set(_vm.modelValue, "parentWheezingRate", $$v)},expression:"modelValue.parentWheezingRate"}}),_c('basic-question',{attrs:{"kind":"radio","title":"Durante as últimas 4 semanas, quantos dias a criança acordou durante a noite por causa da asma?","questionData":{
      options: {
        Nenhum: 5,
        '1 a 3 dias': 4,
        '4 a 10 dias': 3,
        '11 a 18 dias': 2,
        '19 a 24 dias': 1,
        'Todos os dias': 0,
      },
    },"disabled":_vm.disabled},model:{value:(_vm.modelValue.parentNightAwakeningsRate),callback:function ($$v) {_vm.$set(_vm.modelValue, "parentNightAwakeningsRate", $$v)},expression:"modelValue.parentNightAwakeningsRate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }